import Modal from "./Modal";
import CloseModal from "./CloseModal";
import ConfirmationModal from "./ConfirmationModal/ConfirmationModal";

export default Modal;

export { CloseModal, ConfirmationModal };
